import { render, staticRenderFns } from "./BinsMonitorWidget.vue?vue&type=template&id=de897f20&scoped=true"
import script from "./BinsMonitorWidget.vue?vue&type=script&lang=js"
export * from "./BinsMonitorWidget.vue?vue&type=script&lang=js"
import style0 from "./BinsMonitorWidget.vue?vue&type=style&index=0&id=de897f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de897f20",
  null
  
)

export default component.exports